module.exports = __webpack_public_path__ + "img/AM.fd31f6e7.svg";